import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SearchTableSearchOrdersService } from 'src/app/_services/search-table-search-orders.service';
import * as XLSX from 'xlsx'
import { merge, Observable, of as observableOf } from 'rxjs'
import { catchError, filter, map, startWith, switchMap } from 'rxjs/operators'
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-export-shipping-products',
  templateUrl: './export-shipping-products.component.html',
  styleUrls: ['./export-shipping-products.component.css']
})
export class ExportShippingProductsComponent implements OnInit {
  SearchDatabaseSO2: SearchTableSearchOrdersService | null
  searchorders: FormGroup
  PlaceOrderCustomer3=[];
  labelDataResponse=''
  constructor(private formBuilder:FormBuilder,
    private spinner: NgxSpinnerService,
    private http:HttpClient,
    public dialogRef: MatDialogRef<ExportShippingProductsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {this.PlaceOrderCustomer3=[];
  
    this.PlaceOrderCustomer3=data;
  
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {

    this.searchorders = this.formBuilder.group({
      SelectCostumerSO: [''],
      startDate: [''],
      endDate: [''],
      status:["3"]
    })
  }
  get so () {
    return this.searchorders.controls
  }

  OnChangeSearchOrderExport () {
    
    this.SearchDatabaseSO2 = new SearchTableSearchOrdersService(this.http)
    // If the user changes the sort order, reset back to the first page.

    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
 this.spinner.show();
          return this.SearchDatabaseSO2!.getRepoIssueseDataExport(
            Number(this.so.SelectCostumerSO.value),
            this.so.startDate.value,
            this.so.endDate.value,
            this.so.status.value
          )
        }),
        map(data => {
          // Flip flag to show that loading has finished.
     

          return data
        }),
        catchError(() => {
          this.spinner.hide();
          return observableOf([])
        })
      )
      .subscribe(datas => {
        console.log(datas)
        this.spinner.hide();
        if (datas.length>0) {
          this.labelDataResponse='Process Data'
          this.exportAsExcelItemsShipping(datas)
        } else {
          this.labelDataResponse='No Data'
          
        }
     

      })
  }
  exportAsExcelItemsShipping (data:any) {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
     data
    ) //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx')
  }
}
